module.exports = __webpack_public_path__ + "media/images/good_smiley_selected-d94b6bc90691b8811569bcd324945372.svg";